<template>
  <div>
    <!-- <div :rail="rail" permanent @click="rail = false" class="accueil-drawer">
      <Accueil></Accueil>
    </div>
    <v-main>-->
    <v-sheet>
      <!--<v-img :src="icon" :width="iconWidth" class="mx-auto mb-5"></v-img>
          <h1 class="text-center" :style="styleTitle">{{ agenceName }}</h1>-->
      <div class="container" style="position: relative">
        <v-img
          width="74"
          height="20"
          src="../../assets/images/Group 51.png"
          alt=""
          style="position: absolute; top: 0; left: 0; margin-top: 15px"
          @click="goBackAction()"
        />
      </div>
      <h2
        class="text-center mb-5"
        :style="{
          styleTitle,
          fontFamily: 'Georama',
          fontSize: 24,
          fontWeight: 700,
          marginTop: '35px',
          lineheight: '20px',
        }"
      >
        Commande en cours de traitement
      </h2>
      <!-- <div
        class="text-center mb-15"
        :style="{
          styleTitle,
          fontFamily: 'Georama',
          fontSize: 16,
          fontWeight: 400,
          lineheight: '20px',
        }"
      >
        Vous pouvez suivre son avancée dans l'onglet<br />"Suivi de commande"
      </div> -->
      <v-row align="center" justify="center" class="mt-13">
        <v-col cols="auto">
          <v-card
            width="350"
            height="204"
            style="margin-bottom: 30px"
            :color="color"
            :variant="variant"
            class="rounded-xl pa-2 mx-10"
          >
            <v-row align="center" class="pa-3">
              <v-card-item>
                <v-card-title
                  :style="{
                    fontWeight: 600,
                    fontSize: '16px',
                    fontFamily: Georama,
                    lineHeight: '20px',
                  }"
                  ><span
                    style="
                      font-weight: 700;
                      font-size: 34px;
                      font-family: Georama;
                      line-height: 20px;
                    "
                    class="pr-5"
                    >1</span
                  >Traitement
                </v-card-title>
                <div
                  class="pl-5"
                  style="
                    font-weight: 600;
                    font-size: 14px;
                    font-family: Georama;
                    line-height: 20px;
                  "
                >
                  Votre commande sera analysée par nos équipes
                </div>
                <div
                  class="pl-5"
                  style="
                    font-weight: 400;
                    font-size: 14px;
                    font-family: Georama;
                    line-height: 20px;
                    padding-top: 20px;
                  "
                >
                  Si votre photo ou signature risque d’être refusée par
                  l’administration, vous serez invité, par email ou par votre
                  agence à refaire votre photo ou signature
                  <span style="font-weight: bold">gratuitement</span>.
                </div>
              </v-card-item>
            </v-row>
          </v-card>
          <v-card
            width="350"
            height="204"
            :color="color"
            :variant="variant"
            class="rounded-xl pa-2 mx-10"
          >
            <v-row align="center" class="pa-3">
              <v-card-item>
                <v-card-title
                  :style="{
                    fontWeight: 600,
                    fontSize: '16px',
                    fontFamily: Georama,
                    lineHeight: '20px',
                  }"
                  ><span
                    style="
                      font-weight: 700;
                      font-size: 34px;
                      font-family: Georama;
                    "
                    class="pr-5"
                    >2</span
                  >Validation
                </v-card-title>
                <div
                  class="pl-5"
                  style="
                    font-weight: 600;
                    font-size: 14px;
                    font-family: Georama;
                    line-height: 20px;
                  "
                >
                  Une fois votre commande validée, un code ePhoto sera envoyé à
                  votre agence
                </div>
                <div
                  class="pl-5"
                  style="
                    font-weight: 400;
                    font-size: 14px;
                    font-family: Georama;
                    line-height: 20px;
                    padding-top: 20px;
                  "
                >
                  Merci pour votre confiance.
                </div>
              </v-card-item>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-sheet width="300" class="mx-auto">
        <div class="d-flex flex-column">
          <v-btn
            class="mx-3 rounded-pill mb-5 mt-5"
            width="240px"
            height="52px"
            @click="goBack()"
            :color="buttonValidColor"
            :style="{
              color: buttonTextValidColor,
              fontWeight: 600,
              fontSize: 16,
              fontFamily: 'Georama',
              textTransform: 'none',
            }"
            >Retour à l'accueil
          </v-btn>
        </div>
      </v-sheet>
    </v-sheet>
    <!--</v-main>-->
  </div>
</template>
<script>
import { requestService } from '@/services/request.service'
import { localStorageService } from '@/services/localStorage.service'
//import Accueil from './Accueil.vue'

export default {
  name: 'Payment',
  /*components: {
    Accueil,
  },*/
  data() {
    return {
      confEmail: '',
      email: '',
      firstName: '',
      lastName: '',
      address: '',
      errors: [],
      agenceName: '',
      externalId: '',

      styleTitle: localStorageService.getStyle(location.hostname, 'titleStyle'),
      buttonValidColor: localStorageService.getStyle(
        location.hostname,
        'buttonValidColor',
      ),
      buttonTextValidColor: localStorageService.getStyle(
        location.hostname,
        'buttonTextValidColor',
      ),
      buttonNeutralColor: localStorageService.getStyle(
        location.hostname,
        'buttonNeutralColor',
      ),
      buttonTextNeutralColor: localStorageService.getStyle(
        location.hostname,
        'buttonTextNeutralColor',
      ),
      icon: localStorageService.getStyle(location.hostname, 'icon'),
      iconWidth: localStorageService.getStyle(location.hostname, 'iconWidth'),
      color1: localStorageService.getStyle(location.hostname, 'color1'),
      isClicked: false,
    }
  },
  methods: {
    goBackAction() {
      this.$router.back()
      document.activeElement.blur()
    },
    goBack() {
      this.$router.push({
        name: 'Home',
      })
    },
  },
  mounted() {
    const uuid = localStorageService.getValue('partner_uid')
    if (
      uuid !== undefined &&
      uuid !== null &&
      !localStorageService.getValue('logo')
    ) {
      requestService.get('/partner/uuid/' + uuid).then(response => {
        if (response.data.success) {
          this.agenceName = response.data.name
          if (response.data.logo !== null) this.icon = response.data.logo
          localStorageService.setObject(
            'logo',
            response.data.logo !== null ? response.data.logo : undefined,
          )
          localStorageService.setObject(
            'primaryColor',
            response.data.primaryColor !== null
              ? response.data.primaryColor
              : undefined,
          )
          localStorageService.setObject(
            'secondaryColor',
            response.data.secondaryColor !== null
              ? response.data.secondaryColor
              : undefined,
          )
        }
      })
    }
  },
}
</script>
<style>
.rounded-bottom {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  margin-bottom: 0px;
  background-color: #ffffff;
}
.accueil-drawer {
  width: 300px; /* Ajustez la largeur du drawer selon vos besoins */
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  overflow-y: auto;
}
.photo-icon {
  margin: auto;
  width: 17px;
  height: 12px;
}
.text-align-left {
  display: inline-block;
  vertical-align: middle;
}
</style>
